export const TIPO_SOLICITACAO_PLACA = {
  INOVA: "INOVA",
  TERCEIROS: "TERCEIROS",
} as const;

export type TipoSolicitacaoPlaca =
  (typeof TIPO_SOLICITACAO_PLACA)[keyof typeof TIPO_SOLICITACAO_PLACA];
